/* import __COLOCATED_TEMPLATE__ from './seller-posting-information.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';

class SellerPostingInformationComponent extends Component {
  get compensationMin() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails?.compensationMin ?? assignment.compensationMin;
  }

  get compensationMax() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails?.compensationMax ?? assignment.compensationMax;
  }

  get deliverables() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails
      ? application.applicationDeliverables
      : assignment.assignmentDeliverables;
  }

  get descriptionSanitized() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return htmlSafe(application?.applicationDetails?.descriptionLinkified ?? assignment.descriptionLinkified);
  }

  get estimatedDays() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails?.estimatedDays ?? assignment.estimatedDays;
  }

  get examplesSanitized() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return htmlSafe(application?.applicationDetails?.examplesLinkified ?? assignment.examplesLinkified);
  }

  get isAllowsExpenses() {
    const { application, assignment } = this.args;

    // use value stored on application if one is being viewed
    return application?.isAllowsExpenses ?? assignment.isAllowsExpenses;
  }

  get locationText() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails?.locationText ?? assignment.locationText;
  }

  get totalCompensationRange() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails
      ? application.applicationDetails.totalCompensationRange
      : assignment.totalCompensationRange;
  }

  get scheduleItems() {
    const { application, assignment } = this.args;

    // determine whether to use memorialized version
    return application?.applicationDetails
      ? application.scheduleItems
      : assignment.scheduleItems;
  }

  get sellerFeesCovered() {
    const { application, assignment } = this.args;

    // use value stored on application if one is being viewed
    return application?.sellerFeesCovered ?? assignment.sellerFeesCovered;
  }
}

export default SellerPostingInformationComponent;
